import SyllabusForm from "./SyllabusForm";

export default SyllabusForm;
